import { APP_VERSION } from '@/app/app-version';

interface DeveloperCreditProps {
  className?: string;
  hideVersion?: boolean;
}

export function DeveloperCredit({ className = '', hideVersion = false }: DeveloperCreditProps) {
  const classes = ['developer-credit', className].filter(Boolean).join(' ');

  return (
    <footer className={classes} aria-label="توقيع المطور" dir="rtl">
      <div className="developer-credit-main" dir="ltr">
        <span className="developer-credit-role" dir="ltr" lang="en">
          Concept &amp; Development
        </span>
        <strong className="developer-credit-author">
          <bdi dir="ltr" lang="en">Mohamed Hasan</bdi>
        </strong>
      </div>
      <span className="developer-credit-rights" dir="ltr" lang="en">
        © 2026 All Rights Reserved{hideVersion ? '' : ` · v${APP_VERSION}`}
      </span>
    </footer>
  );
}
